import { Grid, Typography } from '@/components/app'
import { SectionTitle } from './SectionTitle'
import { motion } from 'framer-motion'
import { fadeLeft, fadeRight, fadeUp, viewportOnce } from '@/lib/animations'

interface Step {
    number: string
    title: string
    description: string
    image: string
    position: 'left' | 'right'
}

const steps: Step[] = [
    {
        number: '01.',
        title: 'Browse Collections',
        description: 'Explore thousands of gold and silver jewellery designs curated just for you.',
        image: '/images/select-your-favorite.webp',
        position: 'right',
    },

    {
        number: '02.',
        title: 'Select Your Favorite',
        description: 'Pick the perfect piece from detailed product views with zoom and 360° images.',
        image: '/images/browse-collections.webp ',
        position: 'left',
    },
     {
        number: '03.',
        title: 'Secure Checkout',
        description: 'Pay safely with UPI, cards, net banking, or choose cash on delivery.',
        image: '/images/track-delivery.webp',
        position: 'right',
    },
    {
        number: '04.',
        title: 'Track Delivery',
        description: 'Get real-time updates as your jewellery is carefully packaged and delivered.',
        image: '/images/secure-checkout.webp',
        position: 'left',
    },
]

export function HowItWorksSection() {
    return (
        <section id="how-it-works" className="py-6 md:py-10 lg:py-12">
            <div className="wrapper">
                {/* Section Title */}
                <motion.div
                    className="mb-12 md:mb-16"
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                >
                    <SectionTitle
                        badge="HOW IT WORKS"
                        title="Shopping Made Effortless"
                        subtitle="Four simple steps to own your dream jewellery piece."
                        centered
                    />
                </motion.div>

                {/* Steps Layout */}
                <div className="relative bg-background ">
                    <div className='bg-secondary flex flex-wrap relative after:content-[""] after:absolute after:w-full after:h-full after:inset-0 after:border after:border-background'>
                        {steps.map((step, index) => {
                            const directionClass = `
    flex flex-wrap h-full
    ${index % 2 === 0 ? 'flex-row-reverse' : 'flex-row '}
    ${Math.floor(index / 2) % 2 === 0 ? 'lg:flex-row-reverse' : 'lg:flex-row'}
  `;
                            // Alternate slide direction per step
                            const imageVariant = index % 2 === 0 ? fadeRight : fadeLeft
                            const textVariant = index % 2 === 0 ? fadeLeft : fadeRight

                            return (
                                <div key={index} className='w-full lg:w-1/2 relative z-1'>
                                    <div className="h-full ">
                                        <div className={directionClass}>
                                            {/* Phone Image */}
                                            <div className="w-1/2 border border-transparent">
                                                <motion.div
                                                    className="w-full bg-background h-full flex items-end"
                                                    variants={imageVariant}
                                                    initial="hidden"
                                                    whileInView="visible"
                                                    viewport={viewportOnce}
                                                >
                                                    <img
                                                        src={step.image}
                                                        alt={step.title}
                                                        className="w-full h-auto object-contain"
                                                    />
                                                </motion.div>
                                            </div>

                                            {/* Text Content */}
                                            <div className="w-1/2  border border-transparent">
                                                <motion.div
                                                    className="bg-background h-full p-4 md:p-[30px]"
                                                    variants={textVariant}
                                                    initial="hidden"
                                                    whileInView="visible"
                                                    viewport={viewportOnce}
                                                >
                                                    <div className=' max-w-[300px] mx-auto md:mx-0'>
                                                        <Typography variant="h2" className="font-bold mb-4">
                                                            {step.number}
                                                        </Typography>
                                                        <Typography variant="h5" className="font-semibold mb-3">
                                                            {step.title}
                                                        </Typography>
                                                        <Typography color="muted" variant='caption'>
                                                            {step.description}
                                                        </Typography>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    )
}
